import { queryIntelligentRecommend } from "@/api/activity";
import { useCommonContext } from "@/utils/context/common";
import { platform } from "@/utils/platform";
import useNavigation from "@/utils/useNavigate";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

const pageName = "合集会场页";
export const useRmsActivity = () => {
  const [showNavApp, setShowNavApp] = useState(false);
  const [rmsData, setRmsData] = useState<any>(null);
  const [search] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const commonContext = useCommonContext();
  const { navigate2Home, navigate2Cart } = useNavigation();
  const { track } = commonContext;

  let planId = search.get("planId");

  //   初始化app打开
  const initNavApp = () => {
    try {
      if (!platform.isH5) {
        setShowNavApp(true);
        return;
      }
      const showDate = localStorage.getItem("showNavAppDate");
      if (showDate) {
        setShowNavApp(Date.now() - Number(showDate) > 24 * 60 * 60 * 1000);
      } else {
        setShowNavApp(true);
      }
    } catch (e) {
      console.log(e);
      setShowNavApp(false);
    }
  };
  //    关闭app打开
  const onCloseNavApp = () => {
    setShowNavApp(false);
    localStorage.setItem("showNavAppDate", Date.now().toString());
  };
  // 打开app
  const onOpenNavApp = () => {
    console.log("打开app");
  };

  const getRmsData = () => {
    setLoading(true);
    queryIntelligentRecommend({
      planId: Number(planId),
      pageId: "Mini_Program_Search",
    })
      .then((res: any) => {
        setRmsData(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const goHome = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e?.stopPropagation();
    navigate2Home();
  };

  const goBack = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    goHome(e);
  };

  const goCart = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e?.stopPropagation();
    navigate2Cart();
  };

  React.useEffect(() => {
    getRmsData();
  }, [planId]);

  return {
    loading,
    setLoading,
    planId,
    pageName,
    track,
    search,
    showNavApp,
    setShowNavApp,
    rmsData,
    setRmsData,
    onCloseNavApp,
    onOpenNavApp,
    initNavApp,
    commonContext,
    goBack,
    goHome,
    goCart,
  };
};
